import {$,JQuery} from 'jquery';

import ngRoute from 'angular-route';
import ngResource from 'angular-resource';
import ngCookies from 'angular-cookie';
import ngSanitize from 'angular-sanitize';

//this bootstraps all the controllers and services
import * as services from '../dnareport/services';
import * as controllers from '../dnareport/controllers';
require('../util/utility');


let shimStringToJSON = (val) => {
  if(typeof val == "string"){
    return JSON.parse(val);
  }
  return val;
}

(function() {

    let globalText = null;
    let reportdata = {};
    let disorderData = null;

    let config = null;

    var initInjector = angular.injector(['ng']);
    var $http = initInjector.get("$http");

    fetchConfig();

    function fetchConfig() {

        var location = window.location;
        console.log(location.protocol + ' ' + location.host);
        var configUrl = window.location.protocol + '//' + window.location.host + '/api/config';

        console.log('configUrl: ' + configUrl);
        return $http.get(configUrl).then(function(response) {

            config = response.data;

            fetchSampleData();
            fetchDisorderData();

        }, function(response) {
            // is this enough to handle the failed condition?
            // TODO: we need to work on routing to an error module.
            console.log('config response\n' + JSON.stringify(response.data, null, 2));
        });
    }

    function fetchSampleData() {
        let lastSlash = window.location.pathname.lastIndexOf("/");
        var token = window.location.pathname.substring(lastSlash + 1, window.location.pathname.length );
        var repoUrl = window.location.protocol + '//' + window.location.host + '/api/dnareport/' + token;


        return $http.get(repoUrl).then(function(response) {

            var results = response.data;
            reportdata.resultString = shimStringToJSON(results.resultString);
            reportdata.sampleDetails = shimStringToJSON(results.sampleDetails);
            reportdata.reportDetails = shimStringToJSON(results.reportDetails);
            reportdata.ancestryChartJSON = shimStringToJSON(results.ancestryChartJSON);
            reportdata.locale = config.locale[reportdata.sampleDetails.testName];
            fetchGlobalData();

        }, function(response) {
        // is this enough to handle the failed condition?
        // TODO: we need to work on routing to an error module.
            console.log('response\n' + JSON.stringify(response.data, null,2));
        });

    }

    function fetchGlobalData() {

        return $http.get(config.contentful.url + config.contentful.spaceid + '/entries/' + config.contentful.globaltextentryid + '/?access_token=' + config.contentful.access_token + '&locale=' + reportdata.locale)
            .then(function(response) {
                   globalText = response.data.fields['globalText'];
                   bootstrapApplication();
          });
      }

    function fetchDisorderData() {
        return $http.get(config.contentful.url + config.contentful.spaceid +'/entries/?access_token=' +
                config.contentful.access_token +
                '&content_type=disorder&limit=250&select=sys.id,fields.diseaseLongName,fields.diseaseCategory,fields.diseaseName,' +
                'fields.clinicalDescription,fields.keySigns,fields.onsetAge,fields.diseaseSeverity,fields.likelihood,fields.whatIsTheDisease,fields.vetandConsumerText,'+
                'fields.twoCopyMale,fields.twoCopyFemale,fields.oneCopyMale,fields.oneCopyFemale,fields.enabled,fields.locusName,fields.modeOfInheritance&order=fields.diseaseCategory')
            .then(function(response) {
                disorderData = response.data.items;
        });
    }

      function bootstrapApplication() {
           angular.element(document.body).ready(function() {
            let modules = [ngRoute,
                           ngSanitize,
                           ngResource,
                           "ui.bootstrap",
                           "mars.vet.dnareports.services",
                           "mars.vet.dnareports.controllers"];

            angular.module("mars.vet.dnareports.printreport.app",modules); // the app module definition
            angular.module("mars.vet.dnareports.printreport.app").constant('config', config);
            angular.module("mars.vet.dnareports.printreport.app").constant('reportdata', reportdata);
            angular.module("mars.vet.dnareports.printreport.app").constant('globalText', globalText);
            angular.module("mars.vet.dnareports.printreport.app").constant("disorderData", disorderData);
            angular.bootstrap(document.body, ["mars.vet.dnareports.printreport.app"]);

        });
    }
}());



// WEBPACK FOOTER //
// ./client/apps/printreport/index.js